import { reactions } from '../../../common/types/user-info';

export const emotions = ['smile'] as const;

export const SELF = 'self';

export const CLIENT_ID = 'telemost_front';

// Дефолтное значение для всех модальных окон
export const DEFAULT_MODAL_Z_INDEX = 3001;

export const FEEDBACK_COUNT_STORAGE_KEY = 'feedbackCount';

export { reactions };
